import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAdminGuard } from '../../hooks/useAdminGuard';

const NAV = [
  { to: '/dashboard', icon: '◇', label: 'Dashboard' },
  { to: '/packages',  icon: '▦', label: 'Packages' },
  { to: '/income',    icon: '◐', label: 'Income' },
  { to: '/team',      icon: '◈', label: 'Team' },
  { to: '/activity',  icon: '☰', label: 'Activity' }
];

const ADMIN_ITEM = { to: '/admin', icon: '✦', label: 'Admin', adminOnly: true };

const useNav = () => {
  const guard = useAdminGuard();
  return guard.canAccess ? [...NAV, ADMIN_ITEM] : NAV;
};

const Sidebar = () => {
  const items = useNav();
  return (
    <aside className="sidebar">
      {items.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''} ${n.adminOnly ? 'admin' : ''}`}
        >
          <span className="sidebar-icon">{n.icon}</span>
          <span>{n.label}</span>
        </NavLink>
      ))}
    </aside>
  );
};

export const MobileNav = () => {
  const items = useNav();
  return (
    <nav className="mobile-nav">
      {items.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          className={({ isActive }) => `item ${isActive ? 'active' : ''} ${n.adminOnly ? 'admin' : ''}`}
        >
          <span className="icon">{n.icon}</span>
          <span>{n.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default Sidebar;
